<template>
  <div 
    class="  px-10 mt-12">
    <v-layout wrap>
      <v-flex>
        <section>
          
          <div class="color-dark-blue fs-22 font-weight-bold">
            Ubah Surat Jalan
          </div>

          <v-card flat v-if="process.load" >
            <v-card-text
              v-if="process.load" 
              class="pb-0 my-4" 
              style="height: calc(100vh - 350px); display: flex; align-items: center; justify-content: center;">
              <div class="text-center">
                <div class="mb-4 title">
                  Mohon Tunggu . . .
                </div>

                <v-progress-linear
                  :color="set_color"
                  indeterminate
                  rounded
                  height="10">
                </v-progress-linear>
              </div>
            </v-card-text>
          </v-card>

          <v-row
            class="" v-if="!process.load">
            <v-col 
              cols="11"
              class="px-0">
              <v-card 
                flat
                style="background: transparent;">
                <v-card-text>
                  <ValidationObserver 
                    ref="form">
                    <v-form>
                      <!-- <div
                        class="mb-4">
                        <div 
                          class="body-2 mb-2">
                          Poto Profil
                        </div>

                        <uploadfolder v-if="form.image_url === ''"
                          v-model="upload.image">
                          <div 
                            slot="activator">
                            <v-card 
                              flat
                              width="200"
                              height="200"
                              class="d-flex align-center justify-center cursor-pointer"
                              style="border-radius: 15px;
                                    border: 2px solid #EBEBEB; 
                                    border-style: dashed;">
                              <v-avatar v-if="!process.image"
                                v-ripple
                                tile 
                                width="200"
                                height="200">
                                <v-icon
                                  size="50"
                                  color="#B9B9B9">
                                  mdi-cloud-upload-outline
                                </v-icon>
                              </v-avatar>

                              <v-progress-circular v-else
                                indeterminate
                                :color="set_color">
                              </v-progress-circular>
                            </v-card>
                          </div>
                        </uploadfolder>

                        <v-card v-if="form.image_url !== ''"
                          flat
                          width="200"
                          height="200"
                          class="d-flex align-center justify-center"
                          style="border-radius: 15px;
                                border: 2px solid #EBEBEB; 
                                border-style: dashed;">
                          <v-avatar
                            v-ripple
                            tile 
                            size="200"
                            style="border-radius: 15px;">
                            <v-img 
                              contain
                              width="100%"
                              height="100%"
                              alt="Mitra Warung" 
                              :src="form.image_url"
                              class="ma-auto"
                              style="border-radius: 15px;">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    :color="set_color">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </v-avatar>

                          <v-icon 
                            @click="form.image_url = ''"
                            color="red"
                            class="cursor-pointer"
                            style="position: absolute; top: -10px; right: -10px;">
                            mdi-close-circle
                          </v-icon>
                        </v-card>
                      </div> -->

                      <v-row>

                        <!-- <v-col
                          cols="12"
                          md="12" class="pt-0">

                          <ValidationProvider
                            name="No Order" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-15 label-input">
                              No Order
                            </div>
      
                            <v-autocomplete
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
      
                              color="#718EBF"
                              placeholder="No Order"
                              v-on:change="changeOrder()"
      
                              
                              :items="order"
                              item-value="id"
                              item-text="number"
                              :item-color="set_color"
      
                              v-model="form.order_id"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-autocomplete>
                          </ValidationProvider>
                        </v-col> -->
                        
                        <v-col
                          cols="12"
                          md="6" class="pt-0">

                          <!-- <ValidationProvider
                            name="No surat jalan" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-15 label-input">
                              No surat jalan
                            </div>
      
                            <v-autocomplete
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
      
                              color="#718EBF"
                              placeholder="No surat jalan"
      
                              
                              :items="pembelian"
                              item-value="id"
                              item-text="number"
                              :item-color="set_color"
      
                              v-model="form.no_surat_jalan"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-autocomplete>
                          </ValidationProvider> -->



                          <ValidationProvider
                            name="Nama Driver" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-15 label-input">
                              <!-- <span class="red--text">*</span> -->
                              Nama Driver
                            </div>
      
                            <v-autocomplete
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
      
                              color="#718EBF"
                              placeholder="Nama Driver"
      
                              
                              :items="driver"
                              item-value="id"
                              item-text="name"
                              :item-color="set_color"
      
                              v-model="form.driver_id"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-autocomplete>
                          </ValidationProvider>

                          <div class="fs-15 label-input">
                          <!-- <span class="red--text">*</span> -->
                          
                            Tanggal kirim
                          </div>
            
                          <v-menu
                            v-model="menu2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                            >
                            <template v-slot:activator="{ on, attrs }">
                              <ValidationProvider 
                                name="Tanggal Kirim" 
                                rules="required" 
                                v-slot="{ errors }">
                                <v-text-field
                                  v-model="form.date"
                                  
                                  v-on:keyup.enter="save()"
                                  
                                  filled
                                  solo
                                  rounded
                                  dense
                                  
                                  :color="set_color"
                                  placeholder="Tanggal Kirim"
            
                                  :disabled="Object.keys(form).length < 1"
            
                                
            
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  >
                                </v-text-field>
                              </ValidationProvider>
                            </template>
                            <v-date-picker
                              v-model="form.date"
                              :min="new Date().toISOString().substr(0, 10)"
                              @input="menu2 = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col
                          cols="12"
                          md="6" class="pt-0">
                          <!-- <ValidationProvider
                            name="No BPB" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-15 label-input">
                              No BPB
                            </div>
      
                            <v-autocomplete
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
      
                              color="#718EBF"
                              placeholder="No BPB"
      
                              
                              :items="pembelian"
                              item-value="id"
                              item-text="number"
                              :item-color="set_color"
      
                              v-model="form.no_bpb"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-autocomplete>
                          </ValidationProvider> -->

                          <ValidationProvider
                            name="Nama Vehicle" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-15 label-input">
                              <!-- <span class="red--text">*</span> -->
                              Nama Vehicle
                            </div>
      
                            <v-autocomplete
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
      
                              color="#718EBF"
                              placeholder="Nama Vehicle"
      
                              
                              :items="vehicle"
                              item-value="id"
                              :item-text="item => `${item.name} - ${item.number}`"
                              :item-color="set_color"
      
                              v-model="form.vehicle_id"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:selection="{ item }">
                                <div
                                  v-if="item" style="">
                                  {{ item.name }} - {{ item.number }}
                                </div>
                              </template>
                              <template v-slot:item="{ item }">
                                <v-list-item-content>
                                  <v-list-item-title>{{ item.name }} - {{ item.number }}</v-list-item-title>
                                </v-list-item-content>
                              </template>
                            </v-autocomplete>
                          </ValidationProvider>

                        </v-col>
                        <v-col cols="12">
                          <div 
                            class="fs-15 label-input">
                            <!-- <span class="red--text">*</span> -->
                            Catatan
                          </div>
      
                          <v-textarea
                            v-on:keydown.enter.prevent="save()"
                            
                            filled
                            rounded
                            dense
                            solo
      
                            color="#718EBF"
                            placeholder="Catatan"
                            row="3"
      
                            
      
                            v-model="form.note"
                            style="border-radius: 10px;">
                          </v-textarea>
                        </v-col>
                      </v-row>

                    </v-form>
                  </ValidationObserver>

                  <div v-if="!process.load && Object.keys(detail).length > 0">
                    <div class="mt-5">
                      Detail Order
                    </div>

                    <v-divider
                      class="my-4">
                    </v-divider>

                    <div v-for="(items, indexs) in detail.bpb" :key="indexs">
                      <v-card flat class="mb-5">
                        <v-card-text>
                          <v-row>
                            <v-col>
                              <div>
                                <div class="mb-1 input-label">
                                  Nomer BPB
                                </div>
                                <div class="fs-18 font-weight-bold">
                                  {{ items.bpb_number }}
                                </div>
                              </div>
                            </v-col>
                            <!-- <v-col>
                              <div>
                                <div class="mb-1 input-label">
                                  Nama Sales
                                </div>
                                <div class="fs-18 font-weight-bold">
                                  {{ items.sales_name }}
                                </div>
                              </div>
                            </v-col> -->

                            <v-col>
                              <div>
                                <div class="mb-1 input-label">
                                  Nama Customer
                                </div>
                                <div class="fs-18 font-weight-bold">
                                  {{ items.customer_name }}
                                </div>
                              </div>
                            </v-col>
                            <v-col>
                              <div>
                                <div class="mb-1 input-label">
                                  Nomer Order 
                                </div>
                                <div class="fs-18 font-weight-bold">
                                  {{ items.orders_number }}
                                </div>
                              </div>
                            </v-col>
                          </v-row>

                          <!-- <v-row>
                            <v-col>
                              <div class="mb-2">
                                <div class="mb-1 input-label">
                                  Alamat
                                </div>
                                <div class="fs-16 font-weight-bold">
                                  {{ items.shipping_address }}
                                </div>
                              </div>

                              <div class="mb-2">
                                <div class="mb-1 input-label">
                                  Kelurahan
                                </div>
                                <div class="fs-16 font-weight-bold">
                                  {{ items.shipping_village }}
                                </div>
                              </div>
                            </v-col>
                            <v-col>
                              <div class="mb-2">
                                <div class="mb-1 input-label">
                                  Kecamatan
                                </div>
                                <div class="fs-16 font-weight-bold">
                                  {{ items.shipping_subdistrict }}
                                </div>
                              </div>

                              <div class="mb-2">
                                <div class="mb-1 input-label">
                                  Kabupaten
                                </div>
                                <div class="fs-16 font-weight-bold">
                                  {{ items.shipping_city }}
                                </div>
                              </div>
                            </v-col>
                            <v-col>
                              <div class="mb-2">
                                <div class="mb-1 input-label">
                                  Provinsi
                                </div>
                                <div class="fs-16 font-weight-bold">
                                  {{ items.shipping_province }}
                                </div>
                              </div>

                            </v-col>
                            <v-col>
                              <div>
                                <div class="mb-1 input-label">
                                  Nama Kelurahan
                                </div>
                                <div class="fs-18 font-weight-bold">
                                  {{ items.sales_name }}
                                </div>
                              </div>
                            </v-col>

                            <v-col>
                              <div>
                                <div class="mb-1 input-label">
                                  Nama Kecamatan
                                </div>
                                <div class="fs-18 font-weight-bold">
                                  {{ items.customer_name }}
                                </div>
                              </div>
                            </v-col>
                            <v-col>
                              <div>
                                <div class="mb-1 input-label">
                                  Nama Kabupaten
                                </div>
                                <div class="fs-18 font-weight-bold">
                                  {{ detail.customer_name }}
                                </div>
                              </div>
                            </v-col>
                            <v-col>
                              <div>
                                <div class="mb-1 input-label">
                                  Nama Provinsi
                                </div>
                                <div class="fs-18 font-weight-bold">
                                  {{ detail.customer_name }}
                                </div>
                              </div>
                            </v-col>
                          </v-row>
                          <v-divider
                            class="my-4">
                          </v-divider> -->
                        </v-card-text>
                      </v-card>
                      <div v-for="(item, index) in items.detail" :key="index">
                        <!-- <table width="100%" style="border-bottom: thin solid #E6EFF5;">
                          <thead>
                            <tr>
                              <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">Nama Barang</th>
                              <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">No. SKU</th>
                              <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">Qty</th>
                              <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">Qty Lusin</th>
                              <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">Qty Dus</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(item, index) in form.varian_arr" :key="index">
                              <td class="text-left label-input fs-16 font-weight-bold pa-2">{{ item.detail_varian_name }}</td>
                              <td class="text-left label-input fs-16 font-weight-bold pa-2">{{ item.detail_varian_sku }}</td>
                              <td class="text-left label-input fs-16 font-weight-bold pa-2">{{ item.detail_qty_pcs_approved }}</td>
                              <td class="text-left label-input fs-16 font-weight-bold pa-2">{{ item.detail_qty_lusin_approved }}</td>
                              <td class="text-left label-input fs-16 font-weight-bold pa-2">{{ item.detail_qty_dus_approved }}</td>
                            </tr>
                          </tbody>
                        </table> -->
                        <v-card flat class="mb-5">
                          <v-card-text>
                            <div class="fs-16 font-weight-bold label-input">
                              {{ item.varian_name }}
                            </div>
                            <div>
                              <span>Kode SKU</span>: <span>{{ item.varian_sku }}</span>
                            </div>
                            <!-- <div>
                              <span>Harga</span>: <span>{{ item.price | price }}</span>
                            </div> -->

                            <v-row class="pt-3">
                              <!-- <v-col>
                                <div class="fs-15 label-input">
                                  Harga
                                </div>
        
                                <div class="fs-19 font-weight-bold label-input mt-5">
                                  {{ item.price | price }}
                                </div>
                              </v-col> -->

                              <v-col class="py-0">
                                <div 
                                  class="fs-15 label-input">
                                  Qty Pcs
                                </div>
          
                                <div class="fs-19 font-weight-bold label-input mt-5">
                                  {{ item.qty_pcs }}
                                </div>
                                <!-- <div class="fs-15 label-input">
                                  Qty
                                </div>
        
                                <v-currency-field
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
            
                                  color="#718EBF"
                                  placeholder="Qty"

                                  
            
                                  v-model="item.qty"
                                  required
                                  style="border-radius: 10px;">
                                </v-currency-field> -->
                              </v-col>
                              <!-- <v-col class="py-0">
                                <ValidationProvider
                                  :name="`Qty Pcs ${item.name}`"
                                  :rules="`required|max_value:${item.qty_pcs_approve}|min_value:0`" 
                                  v-slot="{ errors }">
                                  <div 
                                    class="fs-15 label-input">
                                    Qty Pcs
                                  </div>
            
                                  <v-currency-field
                                  
                                    filled
                                    rounded
                                    dense
                                    solo
              
                                    color="#718EBF"
                                    placeholder="Qty"

                                    
              
                                    v-model="item.qty_pcs"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;">
                                  </v-currency-field>
                                </ValidationProvider>
                              </v-col> -->

                              <!-- <v-col>
                                <div class="fs-15 label-input">
                                  Harga Beli
                                </div>
        
                                <v-currency-field
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
            
                                  color="#718EBF"
                                  placeholder="Harga Beli"
                                  
            
                                  v-model="item.harga_beli"
                                  required
                                  style="border-radius: 10px;">
                                </v-currency-field>
                              </v-col>

                              <v-col>
                                <div class="fs-15 label-input">
                                  PPN Beli
                                </div>
        
                                <v-currency-field
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
            
                                  color="#718EBF"
                                  placeholder="PPN Beli"
                                  
            
                                  v-model="item.ppn_beli"
                                  required
                                  style="border-radius: 10px;">
                                </v-currency-field>
                              </v-col> -->
                              <v-col class="py-0">
                                <div 
                                  class="fs-15 label-input">
                                  Qty Lusin
                                </div>
          
                                <div class="fs-19 font-weight-bold label-input mt-5">
                                  {{ item.qty_lusin }}
                                </div>
                                <!-- <div class="fs-15 label-input">
                                  Qty
                                </div>
        
                                <v-currency-field
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
            
                                  color="#718EBF"
                                  placeholder="Qty"
      
                                  
            
                                  v-model="item.qty"
                                  required
                                  style="border-radius: 10px;">
                                </v-currency-field> -->
                              </v-col>


                              <v-col class="py-0">
                                <div 
                                  class="fs-15 label-input">
                                  Qty Dus
                                </div>
                                <div class="fs-19 font-weight-bold label-input mt-5">
                                  {{ item.qty_dus }}
                                </div>
            
                                  
                                <!-- <div class="fs-15 label-input">
                                  Qty
                                </div>
        
                                <v-currency-field
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
            
                                  color="#718EBF"
                                  placeholder="Qty"

                                  
            
                                  v-model="item.qty"
                                  required
                                  style="border-radius: 10px;">
                                </v-currency-field> -->
                              </v-col>
                            </v-row>

                            <v-row>
                              <!-- <v-col>
                                <div class="fs-15 label-input">
                                  Harga
                                </div>
        
                                <div class="fs-19 font-weight-bold label-input mt-5">
                                  {{ item.price | price }}
                                </div>
                              </v-col> -->

                              <!-- <v-col class="py-0">
                                <ValidationProvider
                                  :name="`Qty Lusin ${item.name}`"
                                  :rules="`required|max_value:${item.qty_lusin_approve}|min_value:0`" 
                                  v-slot="{ errors }">
                                  <div 
                                    class="fs-15 label-input">
                                    Qty Lusin
                                  </div>
            
                                  <v-currency-field
                                  
                                    filled
                                    rounded
                                    dense
                                    solo
              
                                    color="#718EBF"
                                    placeholder="Qty"

                                    
              
                                    v-model="item.qty_lusin"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;">
                                  </v-currency-field>
                                </ValidationProvider>
                              </v-col> -->

                              <!-- <v-col>
                                <div class="fs-15 label-input">
                                  Harga Beli
                                </div>
        
                                <v-currency-field
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
            
                                  color="#718EBF"
                                  placeholder="Harga Beli"
                                  
            
                                  v-model="item.harga_beli"
                                  required
                                  style="border-radius: 10px;">
                                </v-currency-field>
                              </v-col>

                              <v-col>
                                <div class="fs-15 label-input">
                                  PPN Beli
                                </div>
        
                                <v-currency-field
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
            
                                  color="#718EBF"
                                  placeholder="PPN Beli"
                                  
            
                                  v-model="item.ppn_beli"
                                  required
                                  style="border-radius: 10px;">
                                </v-currency-field>
                              </v-col> -->
                            </v-row>

                            <v-row>
                              <!-- <v-col>
                                <div class="fs-15 label-input">
                                  Harga
                                </div>
        
                                <div class="fs-19 font-weight-bold label-input mt-5">
                                  {{ item.price | price }}
                                </div>
                              </v-col> -->

                              <!-- <v-col class="py-0">
                                <ValidationProvider
                                  :name="`Qty Dus ${item.name}`" 
                                  :rules="`required|max_value:${item.qty_dus_approve}|min_value:0`" 
                                  v-slot="{ errors }">
                                  <div 
                                    class="fs-15 label-input">
                                    Qty Dus
                                  </div>
            
                                  <v-currency-field
                                  
                                    filled
                                    rounded
                                    dense
                                    solo
              
                                    color="#718EBF"
                                    placeholder="Qty"

                                    
              
                                    v-model="item.qty_dus"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;">
                                  </v-currency-field>
                                </ValidationProvider>
                              </v-col> -->

                              <!-- <v-col>
                                <div class="fs-15 label-input">
                                  Harga Beli
                                </div>
        
                                <v-currency-field
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
            
                                  color="#718EBF"
                                  placeholder="Harga Beli"
                                  
            
                                  v-model="item.harga_beli"
                                  required
                                  style="border-radius: 10px;">
                                </v-currency-field>
                              </v-col>

                              <v-col>
                                <div class="fs-15 label-input">
                                  PPN Beli
                                </div>
        
                                <v-currency-field
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
            
                                  color="#718EBF"
                                  placeholder="PPN Beli"
                                  
            
                                  v-model="item.ppn_beli"
                                  required
                                  style="border-radius: 10px;">
                                </v-currency-field>
                              </v-col> -->
                            </v-row>

                          </v-card-text>
                        </v-card>
                      </div>

                      <v-divider
                        class="my-4">
                      </v-divider>
                    </div>
                  </div>


                  <div v-if="message.error.length > 0"
                    class="text-center my-4 d-flex align-center">
                    <div
                      class="error--text">
                      <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                      
                      <span
                        class="ml-1">
                        {{ message.error }}
                      </span>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            justify="end"
            class="pa-4 pt-0 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="d-flex align-center justify-end py-0">
              <v-btn 
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                width="190"
                height="45"
                elevation="0"
                color="#1814F3"
                class="fs-16 white--text text-capitalize border-radius">
                Simpan
              </v-btn>
              
              <v-btn
                to="/delivery/surat-jalan"
                :disabled="process.form"
                color="red"
                elevation="0"
                width="140"
                height="45"
                class="body-2 white--text text-capitalize d-flex align-center ml-4 border-radius"
                style="font-weight: 600;">
              
                  Batal
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        menu: {
          
        },
        category: [
          {
            title: 'Parsial',
            id: 'Parsial'
          },
          {
            title: 'Full',
            id: 'Full'
          }
        ],
        modal: false,
        menu2: false,

        dialog: {
          customer: false,
          fullscreen: false
        },
        bukti: 'gambar',
        gambar_url: '',
        pdf_url: '',
        category: ['Gambar', 'Pdf'],
        pembelian: [],
        product_id: '',
        selected: [],
        headers: [],
        list: [],
        supplier: [],
        form: {
          id: '',
          date: '',
          driver_id: '',
          note: '',
          vehicle_id: '',
          order_id: '',
          varian_arr: [],
          // category: '',
          // image_url: '',
          // pdf_url: ''
        },
        order_json: {},
        detail: {},
        vehicle: [],
        driver: [],
        order: [],
        headers_data: [],
        supervisor: [],
        branch: [],

        mobilephone: {
          name: '',
          id: ''
        },

        lastIndex: 1,

        upload: {
          pdf_url: null,
          image_url: null
        },

        process: {
          form: false,

          pdf_url: false,

          image_url: false,
          load: false
        },
        
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue'),
      uploaddocument: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/document.vue')
    },
    watch: {
      'upload.pdf_url': {
        handler: function () {
          if (this.upload.pdf_url) {
            this.process.pdf_url = this.upload.pdf_url.process

            if (!this.process.pdf_url) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.pdf_url = this.upload.pdf_url.fileuri

              // this.save_image()
            }
          }
        },
        deep: true
      },

      'upload.image_url': {
        handler: function () {
          if (this.upload.image_url) {
            this.process.image_url = this.upload.image_url.process

            if (!this.process.image_url) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.gambar_url = this.upload.image_url.fileuri

              // this.save_image()
            }
          }
        },
        deep: true
      }
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },
      configHeaders () {
          return this.headers_data.filter(header => !header.hide)  
        },
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      async fetchDetail () {
        this.process.load = true
        let params = {
          id: this.$route.params.id
        }

        await get('admin/surat_jalan/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.detail = res.results.data
            this.form.id = res.results.data.id
            this.form.date = res.results.data.date
            this.form.driver_id = res.results.data.driver_id
            this.form.vehicle_id = res.results.data.vehicle_id
            this.form.note = res.results.data.note
          }
          // this.process.load = false
          this.fetchVehicle()
          this.fetchOrder()
          this.fetchDriver()
        })
      },
      async fetchOrder () {
        // this.process.load = true

        let params = {
          limit: 1000000,
          status: 'persiapan'
          // limit: 1000000,
          // par_id: '1'
        }

        await get(`admin/order/data`, { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.pembelian = res.results.data
            this.order = res.results.data
            
          }
          this.process.load = false
        })
      },
      async fetchVehicle () {
        // this.process.load = true

        let params = {
          limit: 10000000,
          // limit: 1000000,
          // par_id: '1'
        }

        await get(`admin/vehicle/data`, { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.vehicle = res.results.data
            
          }
          this.process.load = false
        })
      },
      async fetchDriver () {
        // this.process.load = true

        let params = {
          limit: 10000000,
          'category_user_id[eq]': '11',
          is_active: 'Aktif',
          // limit: 1000000,
          // par_id: '1'
        }

        await get(`admin/user/data`, { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.driver = res.results.data
            
          }
          this.process.load = false
        })
      },

      changeOrder() {
        this.order_json = {}
        // this.order_json = this.order.find(x => x.id === this.form.order_id)
        this.fetchDetailOrder(this.form.order_id)
      },

      async fetchDetailOrder (id) {
        let params = {
          id: id
        }

        await get('admin/order/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            let data = []
            res.results.data.detail.map((item) => {
              data.push(item)
            })
            this.order_json = res.results.data

            this.form.varian_arr = []
            data.map((item) => {
              this.form.varian_arr.push({
                varian_id: item.detail_varian_id,
                varian_name: item.detail_varian_name,
                varian_sku: item.detail_varian_sku,
                qty_pcs_approve: item.detail_qty_pcs_approved === undefined ? 0 : item.detail_qty_pcs_approved*1,
                qty_lusin_approve: item.detail_qty_lusin_approved === undefined ? 0 : item.detail_qty_lusin_approved*1,
                qty_dus_approve: item.detail_qty_dus_approved === undefined ? 0 : item.detail_qty_dus_approved*1,
                qty_pcs: 0,
                qty_lusin: 0,
                qty_dus: 0,
                
              })
            })


          }
        })
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          let form = {
            id: this.form.id,
            date: this.form.date,
            driver_id: this.form.driver_id,
            vehicle_id: this.form.vehicle_id,
            note: this.form.note
          }
          this.process.form = true

          // SAVE TO REST API
          await post(`admin/surat_jalan/update`, {
            data: form
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {

              this.$router.push({ path: '/delivery/surat-jalan' })

            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>

<style >
table {
  border-collapse: collapse;
  width: 100%;
}

/* tr {
  border-bottom: 1px solid #ddd;
} */
</style>